export default "__VITE_ASSET__0_2LE8ON__"